import { Container, Stack, SxProps } from "@mui/material";
import Page from "src/components/Page";
import useResponsive from "src/hooks/useResponsive";
import StepperIconsFlow from "src/pages/Link/Products/Common/StepperIconsFlow";

import ThemeContext from "../context";
import useTranfersData from "./hooks/useTranfersData";
import TransfersCard from "./TransfersCard";

// ----------------------------------------------------------------------

const containerSx: SxProps = {
	height: "100vh",
	display: "flex",
	justifyContent: "center"
};

const stackSx: SxProps = {
	backgroundColor: "background.default",
	alignItems: "center",
	width: "100%"
};

export const Transfers = () => {
	const { STEPS, contextValue, theme, step } = useTranfersData();
	const isMobile = useResponsive("down", "sm");

	const currentStep = step - 1;
	const activeStep = currentStep === 2 ? 1 : currentStep === 3 ? 2 : currentStep;

	return (
		<Page title='Traspasos'>
			<Container
				maxWidth={false}
				sx={{
					...containerSx,
					backgroundColor: theme?.colors.pageBackground,
					alignItems: "center",
					height: { xs: "auto", sm: "100vh" }
				}}
			>
				<Stack sx={{ ...stackSx, backgroundColor: theme?.colors.pageBackground }}>
					<ThemeContext.Provider value={contextValue}>
						{!isMobile && (
							<StepperIconsFlow
								activeStep={activeStep}
								steps={STEPS}
								sx={{
									opacity: step !== 0 ? 1 : 0,
									width: { xs: "auto", sm: 500, md: 700 },
									mb: 5,
									mt: { xs: 9, sm: 10 }
								}}
							/>
						)}
						<TransfersCard />
					</ThemeContext.Provider>
				</Stack>
			</Container>
		</Page>
	);
};

export default Transfers;
